<div *ngIf="show$ | async" [@fadeOut] [class.not-fullscreen]="notFullscreen" [ngStyle]="{ 'z-index': zIndex }" class="loading">
  <div class="animation">
    <ng-lottie [options]="options" height="100px" width="100px"></ng-lottie>
  </div>
</div>
